import React from 'react';
import { IoCloseSharp } from "react-icons/io5";

const image = 'https://res.cloudinary.com/dahgxnpog/image/upload/v1791137266/gymflow-homepage_gfsucp.png';

const GymflowDetail = ({ viewDetail }) => {
    return <>
        <div className='viewDetail'>
            <div className='detailHeader'>
                <IoCloseSharp
                    className='closeDetail'
                    onClick={() => viewDetail(null)}
                />
            </div>

            <div className='projectDetailContainer'>

                <h1 className='projectName'>
                    GymFlow: A Multi-Tenant Gym Management SaaS
                </h1>

                <div className='lists'>
                    <h2 className='listGeneralName'>Description</h2>
                    <p>
                        GymFlow is a multi-tenant gym management SaaS designed to
                        help gyms manage members, memberships, billing, staff,
                        branches, and attendance from a centralized platform.
                    </p>
                    <p>
                        I built the platform to support real-world gym operations,
                        including multi-branch management, role-based access,
                        membership lifecycle management, billing workflows, and
                        attendance tracking.
                    </p>
                    <p>
                        GymFlow is a commercial product currently used by a paying
                        gym customer.
                    </p>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Technologies Used</h2>

                    <div className='list'>
                        <p>
                            <b>Frontend: </b>
                            React, TypeScript
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Backend: </b>
                            Node.js, NestJS
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Database: </b>
                            PostgreSQL, TypeORM
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Infrastructure: </b>
                            Docker
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Screenshots</h2>

                    <div className='screenshotsContainer'>
                        <div className='slide'>
                            <img
                                src={image}
                                alt='GymFlow dashboard'
                            />
                        </div>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Key Features</h2>

                    <div className='list'>
                        <p>
                            <b>Multi-Tenant Architecture: </b>
                            Supports multiple gyms while keeping each
                            organization's data and operations isolated.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Multi-Branch Management: </b>
                            Enables gyms with multiple branches to manage
                            operations across their locations.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Role-Based Access Control: </b>
                            Provides controlled access to gym features and
                            operations based on staff roles.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Membership Management: </b>
                            Handles member registration, multiple package
                            purchases, renewals, cancellations, and membership
                            activation.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Billing and Invoicing: </b>
                            Supports membership billing, invoicing, and
                            membership-related payment workflows.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Attendance Management: </b>
                            Supports facial recognition, fingerprint,
                            card-based, and manual attendance tracking.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>ZKTeco Integration: </b>
                            Integrates ZKTeco attendance devices with facial
                            recognition and fingerprint verification while
                            validating active memberships.
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Frontend Details</h2>

                    <p className='listDesc'>
                        The frontend is built with React and TypeScript and
                        provides the interfaces used by gym staff to manage
                        members, memberships, branches, billing, and attendance.
                    </p>

                    <div className='list'>
                        <p>
                            <b>Member Management: </b>
                            Interfaces for registering and managing gym members
                            and their memberships.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Branch Operations: </b>
                            Branch-aware workflows for managing gym operations
                            across multiple locations.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Administrative Workflows: </b>
                            Interfaces for staff, memberships, billing, and
                            attendance management.
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Backend Details</h2>

                    <p className='listDesc'>
                        The backend is built with Node.js and NestJS, with
                        PostgreSQL used for persistent data storage.
                    </p>

                    <div className='list'>
                        <p>
                            <b>Multi-Tenant Data Isolation: </b>
                            Implemented tenant-aware application workflows to
                            keep gym data separated.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Authentication and Authorization: </b>
                            Implemented branch-scoped authentication and
                            role-based access control.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Membership Workflows: </b>
                            Developed workflows covering registration,
                            package purchases, renewals, cancellations,
                            invoicing, and membership activation.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Database: </b>
                            PostgreSQL with TypeORM for application data
                            persistence and relational data management.
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Attendance Integration</h2>

                    <p className='listDesc'>
                        One of GymFlow's key integrations is its connection
                        with ZKTeco attendance systems.
                    </p>

                    <div className='list'>
                        <p>
                            <b>Biometric Attendance: </b>
                            Supports facial recognition and fingerprint
                            verification.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Card-Based Check-In: </b>
                            Supports card-based attendance in addition to
                            biometric verification.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Manual Attendance: </b>
                            Provides manual check-in functionality when
                            required.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Membership Validation: </b>
                            Attendance is validated against active membership
                            status.
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Product Impact</h2>

                    <div className='list'>
                        <p>
                            <b>Real-World Usage: </b>
                            GymFlow has progressed from development into
                            commercial use with its first annual-paying gym
                            customer.
                        </p>
                    </div>

                    <div className='list'>
                        <p>
                            <b>Operational Coverage: </b>
                            The platform brings membership, billing, staff,
                            branch, and attendance workflows together in one
                            system.
                        </p>
                    </div>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>My Contribution</h2>

                    <p>
                        I designed and developed the core application,
                        implementing the frontend, backend services, database
                        workflows, authentication and authorization, membership
                        and billing functionality, and the ZKTeco attendance
                        integration.
                    </p>
                </div>

                <div className='lists'>
                    <h2 className='listGeneralName'>Interested in a Demo?</h2>

                    <p>
                        GymFlow is a commercial product and its source code and
                        live environment are not publicly available.
                        <a href='#Contact'> Contact me</a> if you would like
                        to learn more or request a product demonstration.
                    </p>
                </div>

            </div>
        </div>
    </>
}

export default GymflowDetail